import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// ── تحديث إجباري صامت — بمجرد اكتشاف نسخة جديدة، نأمرها بالاستيلاء فوراً
// بدون أي تنبيه أو انتظار موافقة المستخدم. controllerchange بالأسفل يتكفّل
// بإعادة تحميل الصفحة تلقائياً فور اكتمال الانتقال الفعلي.
// ⚠️ ملاحظة: هذا يعيد نفس السلوك السابق الذي كان يسبب رسالة أندرويد
// النظامية "تم تحديث هذا التطبيق في الخلفية" (تظهر من النظام نفسه، خارج
// تحكّمنا، عند اكتشافه تحديثات صامتة متكررة)، واحتمال انقطاع إشعارات Push
// لو حدثت إعادة التحميل أثناء جلسة نشطة — قرار مقصود مطلوب من المشروع.
let refreshing = false;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

// تفعيل الـ Service Worker: يجعل التطبيق قابل للتثبيت ويعمل أوفلاين (PWA)
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});
